import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import { DropdownSelectModule } from '../dropdown-select';
import {PaginationModule} from '../pagination';
import {ScrollerModule} from '../scroller';
import {SelectListModule} from '../select-list';
import {InlineEditModule} from '../inline-edit';
import {ResizableModule} from '../resizable';
import {HeaderComponent} from './components/header/header.component';
import {HeaderCellComponent} from './components/header/header-cell.component';
import {FilterComponent} from './components/filter/filter.component';
import {StringFilterComponent} from './components/filter/string-filter.component';
import {ListFilterComponent} from './components/filter/list-filter.component';
import {RangeFilterComponent} from './components/filter/range-filter.component';
import {BodyComponent} from './components/body/body.component';
import {BodyRowComponent} from './components/body/body-row.component';
import {BodyCellComponent} from './components/body/body-cell.component';
import {BodyCellEditComponent} from './components/body/body-cell-edit.component';
import {DataTableComponent} from './components/data-table/data-table.component';

import {BodyMouseoverDirective} from './directives/body-mouseover.directive';
import {BodyKeydownDirective} from './directives/body-keydown.directive';
import {BodyClickDirective} from './directives/body-click.directive';
import {BodyDblClickDirective} from './directives/body-dblclick.directive';
import {BodyContextMenuDirective} from './directives/body-contextmenu.directive';
import {HeaderTemplateDirective} from './directives/header-template.directive';
import { RowGroupTemplateDirective } from './directives/row-group-template.directive';

import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { MatFormFieldModule } from '@angular/material/form-field';//group mat components and give same style to all of them
import { FormsModule } from '@angular/forms';

import { MapsPipeModule } from '../pipes';

//import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// RECOMMENDED
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
//// NOT RECOMMENDED (Angular 9 doesn't support this kind of import)
//import { BsDatepickerModule } from 'ngx-bootstrap';

import { TitlePipeModule } from '../pipes';

import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    ScrollerModule,
    SelectListModule,
    InlineEditModule,
    ResizableModule,

    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    FormsModule,

    //NgxDaterangepickerMd,

    //BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),

    TitlePipeModule,

    MapsPipeModule,

    DropdownSelectModule,
    DirectivesModule,
  ],
  declarations: [
    HeaderComponent,
    HeaderCellComponent,
    FilterComponent,
    StringFilterComponent,
    ListFilterComponent,
    RangeFilterComponent,
    BodyComponent,
    BodyRowComponent,
    BodyCellComponent,
    BodyCellEditComponent,
    DataTableComponent,
    BodyMouseoverDirective,
    BodyKeydownDirective,
    BodyClickDirective,
    BodyDblClickDirective,
    BodyContextMenuDirective,
    HeaderTemplateDirective,
    RowGroupTemplateDirective,
  ],
  exports: [
    DataTableComponent,
    HeaderTemplateDirective,
    RowGroupTemplateDirective,
  ],
  providers: []
})
export class DataTableModule {}
